import config from '@/services/config'
import channel from '@/cqs/channel'
import * as commands from '@/cqs/commands'
import log from '@/services/log';
import Icons from '@/icons'

class SetupModule implements IBoardButtonsProvider {

    public getBoardButtons(t: ITrelloClient, opts:any) : Promise<Array<any>> {
        var self = this;
        return new Promise(resolve => {
            var buttons = [];
            config(t).getSetupIsCompleted().then(isCompleted => {
                if (!isCompleted) {
                    var btn = {
                        icon: {
                            dark: Icons.AppIcon,
                            light: Icons.AppIcon,
                        },
                        text: 'Get started with StoriesOnBoard',
                        callback: function() {
                            self.showSetupModalForOnBoarding(t);
                         },
                        condition: 'edit'
                        };
                    buttons.push(<never>btn);
                    resolve(buttons);
                }
                else {
                    resolve([]);
                }
            }).catch(err => log.err(err))
        });
    }


    public showUserAuth(t: ITrelloClient) {
        return t.popup({
            title: 'Authorize StoriesOnBoard',
            url: './views/auth.html',
            height: 190,
            callback: function(t) {
              return t.NotHandled();
            }
          });
    }


    public showSetupModalForOnBoarding(t: ITrelloClient) {
        t.modal({
            url: '../views/setupwizard/setupwizard.html',
            height: 500,
            fullscreen: false,
            // optional function to be called if user closes modal (via `X` or escape, etc)
            callback: (a) => {
                //a.closePopup()
            },
            // optional title for header chrome
            title: 'Agile Story Maps by StoriesOnBoard'
        });
    }

    public showSetupModal(t: ITrelloClient) {
        return t.modal({
            url: '../views/setupwizard/setupwizard.html',
            height: 500,
            fullscreen: false,
            // optional function to be called if user closes modal (via `X` or escape, etc)
            callback: (a) => {
                //a.closePopup()
            },
            // optional title for header chrome
            title: 'Agile Story Maps by StoriesOnBoard Settings',
            args: { setupMode: 'edit' },
        });
    }


    public disablePowerUp(t: ITrelloClient) {
        return new Promise(resolve => {
            channel(t).sendCommand(new commands.DisablePowerUp()).then(() => {
                resolve(true);
            })
        });
    }
}
export var setupModule : SetupModule = new SetupModule();
export default setupModule;
